import React, { useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from '../Common/TopBar';
import RssManagement from './RssManagement';
import NewsManagement from './NewsManagement';
import UserManagement from './UserManagement';
import FcmManagement from './FcmManagement';
import TopicManagement from './TopicManagement';
import HotTopicsManagement from './HotTopicsManagement';
import CountryManagement from './CountryManagement';
import './Dashboard.css';

const Dashboard = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="dashboard">
      <TopBar />
      <button className="mobile-menu-button" onClick={toggleSidebar}>
        ☰
      </button>
      <div className="dashboard-container">
        <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
        <div className="dashboard-content">
          <Routes>
            <Route path="/" element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="/rss" element={<RssManagement />} />
            <Route path="/news" element={<NewsManagement />} />
            <Route path="/users" element={<UserManagement />} />
            <Route path="/fcm" element={<FcmManagement />} />
            <Route path="/topics" element={<TopicManagement />} />
            <Route path="/hot-topics" element={<HotTopicsManagement />} />
            <Route path="/countries" element={<CountryManagement />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

export default Dashboard; 